<script lang="ts">

import type Numeric from '@/core/types/Numeric';
import { PROGRESS_COLORS } from './ProgressBarSegment';
import type { ProgressColor } from './ProgressBarSegment';

/**
 * VProgressBarSegment — декларативный сегмент прогресс-бара.
 *
 * VProgressBar парсит его из слота, сам компонент ничего не рендерит.
 *
 * value и current принимают число или семантический тип (наследник Numeric).
 * Отрицательные значения берутся по модулю, с предупреждением в консоль.
 *
 * current — часть сегмента, подсвеченная жёлтым (например, текущая заявка
 * внутри «в очереди» или внутри «оплачено»). Рисуется внутри ширины сегмента,
 * в сумму бара отдельно не входит. current больше value — становится value.
 *
 * @example
 * <VProgressBar :total="paymentStatus.total">
 *   <VProgressBarSegment
 *     :value="paymentStatus.payed"
 *     color="green"
 *     :current="payment.isPaid === true ? payment.sum : null"
 *   />
 *   <VProgressBarSegment
 *     :value="paymentStatus.inQueue"
 *     color="blue"
 *     :current="payment.isPaid === false ? payment.sum : null"
 *   />
 * </VProgressBar>
 */
export default defineComponent({
  name: 'VProgressBarSegment',

  props: {
    /**
     * Величина сегмента
     */
    value: {
      type:    [Object, Number] as PropType<Numeric | number | null>,
      default: null,
    },

    /**
     * Цвет сегмента
     */
    color: {
      type:      String as PropType<ProgressColor>,
      required:  true,
      validator: (v: string) => (PROGRESS_COLORS as readonly string[]).includes(v),
    },

    /**
     * Подсвеченная часть сегмента (текущий документ)
     */
    current: {
      type:    [Object, Number] as PropType<Numeric | number | null>,
      default: null,
    },
  },

  render() {
    return null;
  },
});
</script>